import { COLORS } from '../../constants/theme';
import { formatNumber } from '../../utils/format';
import { RANKING_STATS } from '../../constants/rankings';
import { RankingsTable } from './RankingsTable';
import type { RankingsShellProps } from '../../types/rankings';

/**
 * SF-159 Component 2: desktop content — `RankingsTable` plus the "Showing top 100 of {n}, ranked
 * by {stat label}" toolbar caption (restores the mockup's "ranked by" clause, dropped from the
 * v1.0 draft).
 */
export function DesktopRankingsShell({
  entries,
  viewerEntry,
  totalCount,
  currentTick,
  sortBy,
  onSortChange,
}: RankingsShellProps) {
  const statLabel = RANKING_STATS.find((s) => s.key === sortBy)?.label ?? sortBy;

  return (
    <div>
      <RankingsTable
        entries={entries}
        viewerEntry={viewerEntry}
        currentTick={currentTick}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      <p style={{ marginTop: 14, fontSize: 11.5, color: COLORS.text.muted }}>
        Showing top <strong>{formatNumber(entries.length)}</strong> of {formatNumber(totalCount)}, ranked by{' '}
        <strong>{statLabel}</strong>
      </p>
    </div>
  );
}
